export default __webpack_public_path__ + "static/media/key1.ab95d795.svg";